<template>
  <div class="card-feature">
    <div class="card-feature__header">
      <TextProse>
        <h2 v-html="data.header">{{ data.header }}</h2>
        <p v-html="data.text">{{ data.text }}</p>
        <h3 v-html="data.subtitle">{{ data.subtitle }}</h3>
      </TextProse>
    </div>
    <div class="card-feature__image">
      <p v-html="data.feature">{{ data.feature }}</p>
      <figure>
        <img :src="data.image" alt="Alt description for the image">
      </figure>
    </div>
  </div>
</template>

<script>
import TextProse from '../elements/TextProse.vue'

export default {
  name: 'CardFeature',
  components: { TextProse },
  props: ['data']
}
</script>

<style lang="postcss">
.card-feature {
  @apply mt-12 mb-16 flex flex-wrap;
}
.card-feature__header {
  @apply w-full;
}
.card-feature__header .prose h2,
.card-feature__header .prose h3 {
  @apply text-body text-xl;
}
.card-feature__header .prose p {
  @apply mb-6;
}
.card-feature__header .prose {
  @apply mb-4;
}
.card-feature__image {
  @apply flex flex-wrap bg-gradient-tl-primary relative;
}
.card-feature__image::after {
  @apply bg-white w-full h-24 absolute z-0 bottom-0;
  content: '';
}
.card-feature__image p {
  @apply w-full p-8 text-white;
}
.card-feature__image figure {
  @apply w-full h-40 z-10 flex justify-center;
}
.card-feature__image figure img {
  @apply block self-center w-auto max-w-sm max-h-full;
}
@screen sm {
  .card-feature__image {
    @apply flex-no-wrap;
  }
  .card-feature__image p {
    @apply w-8/12;
  }
  .card-feature__image::after {
    @apply w-3/12 h-full right-0;
  }
  .card-feature__image figure {
    @apply w-4/12 h-full justify-start;
  }
  .card-feature__image figure img {
    @apply w-full max-w-full;
  }
}
</style>
